import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { sessionId: Number }

  connect() {
    this.loading = false
    this.hasMore = true
    this.attachScrollListener()

    // On open/re-open, anchor to latest messages
    requestAnimationFrame(() => {
      if (this.hasContainerTarget) {
        this.containerTarget.scrollTop = this.containerTarget.scrollHeight
      }
    })
  }

  disconnect() {
    this.containerTarget?.removeEventListener("scroll", this._onScroll)
  }

  attachScrollListener() {
    if (!this.hasContainerTarget) return
    this._onScroll = this.handleScroll.bind(this)
    this.containerTarget.addEventListener("scroll", this._onScroll)
  }

  async handleScroll() {
    if (this.loading || !this.hasMore || !this.hasContainerTarget) return
    if (this.containerTarget.scrollTop > 40) return

    const oldestMessage = this.containerTarget.querySelector(".axle-msg")
    const beforeId = oldestMessage?.dataset?.messageId
    if (!beforeId) return

    this.loading = true
    const anchor = oldestMessage
    const anchorTopBefore = anchor?.offsetTop || 0

    try {
      const response = await fetch(`/chat/${this.sessionIdValue}/history?before_id=${beforeId}`, {
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) throw new Error(`history load failed: ${response.status}`)
      const data = await response.json()
      this.hasMore = !!data.has_more

      if (Array.isArray(data.messages) && data.messages.length > 0) {
        this.prependMessages(data.messages)

        // Preserve the visible anchor after prepending older messages
        if (anchor) {
          const anchorTopAfter = anchor.offsetTop
          this.containerTarget.scrollTop += (anchorTopAfter - anchorTopBefore)
        }
      }
    } catch (e) {
      console.error("Failed to lazy-load chat history", e)
    } finally {
      this.loading = false
    }
  }

  prependMessages(messages) {
    messages.forEach((message) => {
      const wrapper = document.createElement("div")
      wrapper.className = `axle-msg ${message.role === 'user' ? 'axle-msg-user' : 'axle-msg-axle'}`
      wrapper.dataset.messageId = message.id

      if (message.role === 'assistant') {
        wrapper.innerHTML = `
          <div class="axle-msg-avi">
            <img src="/assets/axle/idle.png" class="axle-msg-avi-img" alt="Axle">
          </div>
          <div class="axle-msg-bubble">
            <div class="prose prose-sm dark:prose-invert max-w-none">${message.formatted_content || ''}</div>
          </div>
        `
      } else {
        wrapper.innerHTML = `
          <div class="axle-msg-bubble">${this.escapeHtml(message.content || '')}</div>
        `
      }

      this.containerTarget.insertBefore(wrapper, this.containerTarget.firstElementChild)
    })
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
